"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRhumb = require("react-rhumb");

var _HubPicker = _interopRequireDefault(require("hub-pickers-lib/components/HubPicker"));

var _UIDropdownSelect = _interopRequireDefault(require("UIComponents/dropdown/UIDropdownSelect"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _AnalyticsPeriod = _interopRequireDefault(require("hub-pickers-lib/constants/AnalyticsPeriod"));

var _I18n = _interopRequireDefault(require("I18n"));

var _actions = require("../actions");

var _API = _interopRequireDefault(require("hub-pickers-lib/Accounts/API"));

var _urls = require("../utils/urls");

var HomeContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(HomeContainer, _Component);

  function HomeContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, HomeContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(HomeContainer).call(this, props));
    _this.onSetAnalyticsPeriod = _this.onSetAnalyticsPeriod.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(HomeContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.getAnalyticsPeriodStart();

      _API.default.getAnalyticsPeriod(this.props.userId).then(function (resp) {
        var analyticsPeriod = _AnalyticsPeriod.default.WEEKLY;

        if (resp.attributes.length === 1) {
          analyticsPeriod = resp.attributes[0].value;
        }

        _this2.props.getAnalyticsPeriodFinish(analyticsPeriod);
      });
    }
  }, {
    key: "onSetAnalyticsPeriod",
    value: function onSetAnalyticsPeriod(e) {
      var _this3 = this;

      _API.default.setAnalyticsPeriod(this.props.userId, e.target.value).then(function () {
        _this3.props.setAnalyticsPeriod(e.target.value);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          filter = _this$props.filter,
          analyticsPeriod = _this$props.analyticsPeriod,
          analyticsPeriodLoading = _this$props.analyticsPeriodLoading,
          query = _this$props.location.query;

      if (analyticsPeriodLoading) {
        return _react.default.createElement(_UILoadingSpinner.default, {
          grow: true,
          minHeight: 200
        });
      }

      return _react.default.createElement(_reactRhumb.NavMarker, {
        name: "INDEX_LOAD"
      }, _react.default.createElement("div", {
        className: "filter"
      }, _I18n.default.text('main.filterText'), _react.default.createElement(_UIDropdownSelect.default, {
        options: [{
          text: _I18n.default.text('main.filterByWeek'),
          value: _AnalyticsPeriod.default.WEEKLY
        }, {
          text: _I18n.default.text('main.filterByMonth'),
          value: _AnalyticsPeriod.default.MONTHLY
        }, {
          text: _I18n.default.text('main.filterByThirtyDay'),
          value: _AnalyticsPeriod.default.THIRTY_DAY
        }],
        value: analyticsPeriod,
        onChange: this.onSetAnalyticsPeriod
      })), _react.default.createElement(_HubPicker.default, {
        redirectTo: (0, _urls.getNextRedirectUrl)(query),
        filter: filter,
        shouldGetAnalytics: true,
        shouldWarnAboutObscured: true,
        analyticsPeriod: analyticsPeriod,
        query: (0, _urls.getRedirectQuery)(query)
      }));
    }
  }]);
  return HomeContainer;
}(_react.Component);

HomeContainer.propTypes = {
  filter: _propTypes.default.string,
  analyticsPeriod: _propTypes.default.string,
  userId: _propTypes.default.number,
  analyticsPeriodLoading: _propTypes.default.bool,
  filterAccounts: _propTypes.default.func,
  setAnalyticsPeriod: _propTypes.default.func,
  getAnalyticsPeriodStart: _propTypes.default.func,
  getAnalyticsPeriodFinish: _propTypes.default.func,
  location: _propTypes.default.shape({
    query: _propTypes.default.object
  })
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    filter: state.accounts.get('filter'),
    analyticsPeriod: state.accounts.get('analyticsPeriod'),
    analyticsPeriodLoading: state.accounts.get('analyticsPeriodLoading'),
    userId: state.auth.user.user_id
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  setAnalyticsPeriod: _actions.setAnalyticsPeriod,
  getAnalyticsPeriodStart: _actions.getAnalyticsPeriodStart,
  getAnalyticsPeriodFinish: _actions.getAnalyticsPeriodFinish
})(HomeContainer);

exports.default = _default;
module.exports = exports.default;